import React, {useEffect, useState} from 'react';
import styles from './index.module.scss'
import Footer from '../../components/footer'
import NavbarMenus from '../../components/navbarMenus'
import Header from '../../components/header'
import { Alert } from 'antd';
import ModuleCode from '../../components/module'
import defGaugeChart from '../../static/image/defGaugeChart.png'
import defGaugeDetailsChart from '../../static/image/defGaugeDetailsChart.png'
import defGradientGaugeChart from '../../static/image/defGradientGaugeChart.png'
import defMoreGaugeChart from '../../static/image/defMoreGaugeChart.png'
import defRoundGaugeChart from '../../static/image/defRoundGaugeChart.png'
import moreRoundGaugeChart from '../../static/image/moreRoundGaugeChart.png'
import {
    defCode,
    changeCode,
    seriesCode,
    gradientOption,
    moreOption,
    roundOption,
    moreRoundOption,
    columns,
    commonData,
    anchorItems,
    seriesData
} from './mock'
import Anchor from "../../components/anchor";

const GettingStarted = () => {
    return (

        <div className={styles.modules}>
            <div className={styles.navbar} id='nav'>
                <NavbarMenus path="McGaugeChart"></NavbarMenus>
            </div>
            <div className={styles.view} id='chartView'>
                <Header title='McGaugeChart（仪表盘）'></Header>
                <div className={styles.module}>
                    <Alert
                        message="温馨提示"
                        description="由于本组件基于ArkTS封装，导致无法在浏览器页面实时预览，所以代码效果图是图片，想要实时预览即可复制代码到对应项目；如若给您带来不便，我们深感歉意；感谢使用。"
                        type="warning"
                        showIcon
                    />
                </div>
                <ModuleCode title={'默认'}
                            tips={'- McGaugeChart（仪表盘）作为图表中最常见之一的图表，可以通过以下代码实现系统默认的仪表盘。'}
                            code={defCode} imgUrl={defGaugeChart}
                            apiTitle={'基础属性'}
                            columns={columns} dataSource={commonData}></ModuleCode>

                <ModuleCode title={'动态更新数据'}
                            tips={'- McCharts 组件整体使用@Observed装饰器和@ObjectLink装饰器来监控数据的变化，所以修改数据需要使用Option实例对象的setVal方法来实现'}
                            code={changeCode} imgUrl={defGaugeChart}></ModuleCode>

                <ModuleCode title={'details属性'}
                            tips={'- McGaugeChart（仪表盘）支持通过series中的属性来设置整体仪表盘的属性：角度、颜色、类型等等'}
                            code={seriesCode} imgUrl={defGaugeDetailsChart}
                            apiTitle={'series属性'}
                            columns={columns} dataSource={seriesData}></ModuleCode>

                <ModuleCode title={'渐变色仪表盘'}
                            tips={'- McGaugeChart（仪表盘）支持通过series中的属性来设置渐变色'}
                            apiTitle={'gradientOption'}
                            code={gradientOption} imgUrl={defGradientGaugeChart}></ModuleCode>

                <ModuleCode title={'多组仪表盘'}
                            tips={'- McGaugeChart（仪表盘）支持通过series中的属性来设置多组仪表盘'}
                            apiTitle={'moreOption'}
                            code={moreOption} imgUrl={defMoreGaugeChart}></ModuleCode>

                <ModuleCode title={'环形图'}
                            tips={'- McGaugeChart（仪表盘）支持通过series中的属性来设置展示模式'}
                            apiTitle={'roundOption'}
                            code={roundOption} imgUrl={defRoundGaugeChart}></ModuleCode>

                <ModuleCode title={'多组环形图'}
                            tips={'- McGaugeChart（仪表盘）支持通过series中的属性来设置多组环形图'}
                            apiTitle={'moreRoundOption'}
                            code={moreRoundOption} imgUrl={moreRoundGaugeChart}></ModuleCode>

                <Footer></Footer>
                <Anchor items={anchorItems}></Anchor>
            </div>
        </div>
    )
}

export default GettingStarted
